import React, { useEffect, useState } from "react";
import { HiOutlineArrowSmRight } from "react-icons/hi";
import { useNavigate } from "react-router-dom";
import { deleteVideo } from "../Apis/endpoints";

const Completedpop = ({ onClose, videoId, comscore, Mode }) => {
 const navigate = useNavigate();
 const [score, setScore] = useState(null);
 const [scoreMessage, setScoreMessage] = useState(null);

 const [errorTitle, setErrorTitle] = useState("");
 // State to hold the array of specific error messages
 const [errors, setErrors] = useState([]);

 useEffect(() => {
   if (comscore) {
     // Check for the new error format which includes an 'errors' array
     if (comscore.errors && Array.isArray(comscore.errors) && comscore.errors.length > 0) {
       setErrorTitle(comscore.message || "Analysis Failed"); // Use the message from the API or a fallback
       setErrors(comscore.errors); // Set the array of errors
       setScore(comscore.Communication_Score);
       setScoreMessage(comscore.Coms_message);
     }
     // Fallback for the old, single-message error format
     else if (comscore.message) {
       setErrorTitle(comscore.message);
       setErrors(["Please record/upload again."]); // Wrap it in an array to be compatible
     }
     // This is the success path
     else {
       setScore(comscore.Communication_Score);
       setScoreMessage(comscore.Coms_message);
     }
   }
 }, [comscore]);

 const deleteCurrentVideo = async () => {
   try {
     await deleteVideo(videoId);
     onClose();
   } catch (error) {
     console.error("Delete failed:", error);
     alert(`Error deleting video: ${error.message}`);
   }
 };

 return (
   <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-70 backdrop-blur-sm p-4">
     <div className="bg-white p-6 sm:p-8 md:p-10 rounded-3xl shadow-lg w-11/12 max-w-3xl aspect-[16/9] min-h-[30rem] sm:min-h-[35rem] max-h-[80vh] flex flex-col justify-center items-center text-center relative">
      
       {/* Check if the errors array has items in it */}
      
         <>
           {/* This is the success view. It remains unchanged. */}
           <svg
             width="280" height="180"
             viewBox="0 0 214 192" fill="none" xmlns="http://www.w3.org/2000/svg"
           >
             {/* Your SVG path data here... */}
             <path fill-rule="evenodd" clip-rule="evenodd" d="M53.4892 135.955C53.4892 134.994 54.2726 134.21 55.2338 134.21H60.4675V153.401H55.2338C54.2726 153.401 53.4892 152.617 53.4892 151.656V135.955ZM53.4892 116.294C53.4683 104.525 57.9327 93.199 65.9804 84.6122L68.421 87.072C61.0467 95.0186 56.9574 105.465 56.9784 116.308V130.721H55.2338C54.6407 130.728 54.0475 130.829 53.4892 131.035V116.294ZM138.715 84.6262C146.749 93.2129 151.213 104.539 151.185 116.294V131.035C150.627 130.829 150.034 130.728 149.441 130.721H147.696V116.294C147.717 105.46 143.628 95.0116 136.253 87.072L138.715 84.6262ZM151.185 151.656C151.185 152.617 150.402 153.401 149.441 153.401H144.207V134.21H149.441C150.402 134.21 151.185 134.994 151.185 135.955V151.656ZM55.2338 156.89H60.4675C60.4745 159.779 62.8122 162.116 65.7012 162.123H72.6795C75.5685 162.116 77.9062 159.779 77.9132 156.89V130.721C77.9062 127.832 75.5685 125.494 72.6795 125.487H65.7012C62.8122 125.494 60.4745 127.832 60.4675 130.721V116.308C60.4605 106.393 64.2026 96.8451 70.9349 89.5668C72.8295 91.5573 75.9506 91.7266 78.0493 89.9488C84.9124 84.3261 93.5323 81.2871 102.405 81.3691C111.231 81.301 119.804 84.3331 126.625 89.9349C128.724 91.7213 131.852 91.5643 133.76 89.5668C140.479 96.8451 144.207 106.386 144.207 116.294V130.721C144.2 127.832 141.862 125.494 138.973 125.487H131.995C129.106 125.494 126.768 127.832 126.761 130.721V156.89C126.768 159.779 129.106 162.116 131.995 162.123H138.973C139.566 162.116 140.159 162.015 140.718 161.809V162.123C140.711 165.012 138.373 167.35 135.484 167.357H109.315C106.426 167.35 104.089 165.012 104.082 162.123V141.536C110.392 141.203 116.444 138.94 121.424 135.048C123.169 133.57 124.165 131.389 124.144 129.099V118.108C124.144 117.815 123.994 117.541 123.748 117.379C123.504 117.222 123.19 117.194 122.925 117.309L107.468 124.158C104.197 125.603 100.477 125.603 97.2064 124.158L81.7495 117.309C81.4843 117.194 81.1703 117.215 80.9261 117.379C80.6801 117.541 80.5301 117.815 80.5301 118.108V129.099C80.5091 131.382 81.5053 133.563 83.2498 135.048C88.2306 138.94 94.2825 141.203 100.593 141.536V162.123C100.593 166.942 104.497 170.846 109.315 170.846H135.484C140.302 170.846 144.207 166.942 144.207 162.123V156.89H149.441C152.33 156.883 154.667 154.545 154.674 151.656V116.294C154.709 103.019 149.42 90.2821 140.002 80.9329C129.978 70.9976 116.383 65.497 102.269 65.6679C88.2166 65.5319 74.6962 71.0168 64.7068 80.898C55.2687 90.2559 49.9722 103.005 50.0001 116.294V151.656C50.0071 154.545 52.3448 156.883 55.2338 156.89Z" fill="black"/>
             <path fill-rule="evenodd" clip-rule="evenodd" d="M106.051 120.968C110.671 118.923 126.217 112.048 130.55 110.118C132.52 109.241 133.793 107.283 133.793 105.124C133.793 102.971 132.52 101.015 130.55 100.136L106.051 89.2655C103.687 88.224 100.989 88.224 98.6229 89.2655L74.1239 100.136C72.1543 101.015 70.8807 102.971 70.8807 105.124C70.8807 107.283 72.1543 109.241 74.1239 110.118C78.3702 112.006 94.0975 118.965 98.6229 120.968C100.989 122.018 103.687 122.018 106.051 120.968Z" fill="black"/>
             <path d="M37.5 6.5L61.5 38.5" stroke="#0F0F0F" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"/>
             <path d="M62.5 15.5L86.5 47.5" stroke="#167F71" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"/>
             <path fill-rule="evenodd" clip-rule="evenodd" d="M175 13.5L169.71 16.2812L170.72 10.3906L166.44 6.21885L172.355 5.35942L175 0L177.645 5.35942L183.56 6.21885L179.28 10.3906L180.29 16.2812L175 13.5Z" fill="#FCC202"/>
             <path fill-rule="evenodd" clip-rule="evenodd" d="M207 71L214 85H200L207 71Z" fill="#167F71"/>
             <circle cx="164" cy="57" r="6" fill="#472D2D"/>
             <path fill-rule="evenodd" clip-rule="evenodd" d="M9 134.5L3.70993 137.281L4.72025 131.391L0.440491 127.219L6.35497 126.359L9 121L11.645 126.359L17.5595 127.219L13.2798 131.391L14.2901 137.281L9 134.5Z" fill="#FF001E"/>
             <path fill-rule="evenodd" clip-rule="evenodd" d="M39 178L46 192H32L39 178Z" fill="#332DA1"/>
             <circle cx="37" cy="147" r="4" fill="#167F71"/>
             <circle cx="20" cy="47" r="6" fill="#FF6B00"/>
           </svg>
           <div className="flex flex-col items-center gap-y-4 mt-4 w-full px-4">
             <p className="text-lg sm:text-2xl font-semibold" style={{ fontFamily: "'Jost', sans-serif" }}>
               Assessment Completed
             </p>
             <p className="text-sm sm:text-base font-medium tracking-wide text-center" style={{ fontFamily: "sans-serif, Archivo" }}>
               Your {scoreMessage} is
               <span className="text-xl font-bold ml-2">{score}</span>
             </p>
 
             {errors && errors.length > 0 && (
               <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded-lg relative w-full max-w-md" role="alert">
                 <ul className="list-disc pl-5 mt-2">
                   {errors.map((error, index) => (
                     <li key={index} className="text-sm">{error}</li>
                   ))}
                 </ul>
               </div>
             )}
 
             {score === '0.00' ? (
               <button
                 className="w-[70%] sm:w-[40%] md:w-[40%] lg:w-[32%] h-auto flex items-center justify-center bg-[#2563EB] text-base md:text-lg font-bold text-white py-2 px-4 rounded-full"
                 onClick={deleteCurrentVideo}
               >
                 Retake
               </button>
             ) : (
               <button
                 className="w-[70%] sm:w-[40%] md:w-[40%] lg:w-[32%] h-auto flex items-center justify-center bg-[#2563EB] text-base md:text-lg font-bold text-white py-2 px-4 rounded-full"
                 onClick={() => navigate(`/result/${videoId}/${Mode}`)}
               >
                 View in detail
                 <span className="ml-4 flex items-center justify-center">
                   <HiOutlineArrowSmRight className="text-2xl text-white" />
                 </span>
               </button>
             )}
             <a href="/upload" className="text-[#2563EB] underline text-base">
               Skip
             </a>
           </div>
         </>
     </div>
   </div>
 );
};

export default Completedpop;
